import { useAppDispatch } from "src/redux/hooks";
import { setError } from "src/redux/slices/errorSlice";

const useMutateError = () => {
  const dispatch = useAppDispatch();
  return (error: Error, source?: string) => {
    dispatch(
      setError({
        error: error.message,
        source: source,
      })
    );
    console.error(error);
  };
};

export default useMutateError;
